import { createContext } from 'react';

import type { StaticRouterContextData } from './types';

export const StaticRouterContext = createContext<StaticRouterContextData | undefined>(undefined);
